module.exports = __webpack_public_path__ + "img/accumulator.43c31ec2.png";